import { List } from "@mantine/core"
import { IconArrowRight } from "@tabler/icons-react"

interface Props {
  children?: React.ReactElement[]
}

export function ArrowList({ children }: Props) {
  return (
    <List icon={<IconArrowRight size={14} />} mt="xs">
      {children?.map((item) => <List.Item key={item.key}>{item}</List.Item>)}
    </List>
  )
}
